import { ILead } from 'src/interfaces/lead';
import { getAreaByWsp } from 'src/utils/areas/getDataAreas';

/**
 *
 *
 * @param {ILead} lead
 * @return {*}
 */
export const getConversationApi = (lead: ILead) => {
    const response = getAreaByWsp({
        area: `${lead?.carType}s`,
        areas: lead?.store?.areas,
    });

    if (response.success) return response.api;
    return false;
};
